const o = "dropdown-portal";
export {
  o as DROPDOWN_PORTAL_ID
};
